// Auto Value Kotlin
import { to_var } from "../utils/to_var";

export function to_kt_moshi_var(key, var_name, var_type, nullable = false) {
  return {
    _class: `\n\t@Json(name = "${key}")\n\tval ${var_name}:${var_type}${
      !nullable ? "" : "?"
    },\n`
  };
}

export function kotlinMoshiParser(class_name, value) {
  let _type = "";
  let _classes = [];
  let _variable_name;
  let _class_name;
  let _default;

  try {
    _variable_name = to_var(class_name);
    _class_name = to_var(class_name, true);
  } catch (e) {
    console.log(e);
  }

  if (value === null) {
    _type = "String";
    _default = '""';
  } else if (typeof value === "string") {
    _type = "String";
    _default = '""';
  } else if (typeof value === "boolean") {
    _type = "Boolean";
    _default = "true";
  } else if (typeof value === "number") {
    if (value % 1 === 0) {
      _type = "Int";
      _default = "0";
    } else {
      _type = "Double";
      _default = "0.0";
    }
  } else if (typeof value === "object") {
    if (Array.isArray(value)) {
      if (value.length === 0 || !value[0]) {
        _type = "List<String>";
        _default = "listOf()";
      } else {
        const { _o_type, _o_classes } = kotlinMoshiParser(
          _variable_name,
          value[0]
        );
        _type = `List<${_o_type}>`;
        _default = "listOf()";
        if (_o_classes.length > 0) {
          _classes = [..._o_classes, ..._o_classes];
        }
      }
    } else {
      _type = _class_name;

      _default = `${_class_name}.builder().build()`;
      let _o_class = `data class ${_class_name} (\n`;
      let _o_builder = "";
      let _o_builder_defaults = "";

      for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          const data = value[key];
          const {
            _o_type,
            _o_classes,
            _o_default,
            _o_variable_name
          } = kotlinMoshiParser(key, data);
          const { _class, _builder } = to_kt_moshi_var(
            key,
            _o_variable_name,
            _o_type,
            false
          );
          _o_class += _class;
          _o_builder += _builder;
          _o_builder_defaults += `${
            _o_builder_defaults ? "." : ""
          }${_o_variable_name}(${_o_default})`;
          if (_o_classes.length > 0) {
            _classes = [..._classes, ..._o_classes];
          }
        }
      }

      _classes.push(`${_o_class}\n)\n`.replace(/\n\s*\n/g, "\n"));
    }
  }

  return {
    _o_type: _type,
    _o_default: _default,
    _o_variable_name: _variable_name,
    _o_classes: [...new Set(_classes)]
  };
}
